// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"04a5ad4b","453":"4f7423c0","553":"5eec28c9","977":"9866b476"}[chunkId] + ".chunk.js";
};